import { createConfig } from "./config/index.js"
import { injectStyles } from "./styles/index.js"
import { createWidget } from "./components/widget.js"

/**
 * Initialize the feedback widget system
 * @param {Object} userConfig - User configuration options
 * @returns {Object} Widget API
 */
export function initializeFeedbackSystem(userConfig = {}) {
  console.log("Initializing feedback system with config:", userConfig)

  // Create normalized configuration
  const config = createConfig(userConfig)

  // Inject required styles
  injectStyles()

  // Create and mount widget
  const widget = createWidget(config)
  document.body.appendChild(widget.element)

  return {
    widget,
    destroy: () => widget.destroy(),
    updateConfig: (newConfig) => {
      const updatedConfig = createConfig({ ...config, ...newConfig })
      console.log("Config updated:", updatedConfig)
      // Implementation for dynamic config updates could go here
    },
  }
}

// Global API
window.FeedbackWidget = initializeFeedbackSystem
